import { useCallback, useEffect, useState } from "react";
import {
  EXPLORE_PAGE_ID,
  parseTrustPageId,
  trustHashFor,
} from "./trustRoutes";

/**
 * Lightweight hash navigation for Explore + trust document pages.
 */
export function useTrustNavigation() {
  const [pageId, setPageId] = useState(() => parseTrustPageId());

  useEffect(() => {
    const sync = () => setPageId(parseTrustPageId());
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, []);

  const navigate = useCallback((nextId) => {
    const id = nextId || EXPLORE_PAGE_ID;
    const nextHash = trustHashFor(id);
    if (window.location.hash === nextHash) {
      setPageId(parseTrustPageId(nextHash));
      return;
    }
    window.location.hash = nextHash;
  }, []);

  const goExplore = useCallback(() => navigate(EXPLORE_PAGE_ID), [navigate]);

  return {
    pageId,
    isExplore: pageId === EXPLORE_PAGE_ID,
    navigate,
    goExplore,
  };
}
